import { Navigate, Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";
import * as routes from "../routes";
import { PERMISSIONS } from "../../consts/permissions";
import { portalLanding } from "../../utils/helpers/portalLanding";

import ProtectedRoute from "./ProtectedRoute";
import PermissionOnComponent from "./PermissionOnComponent";

import SocietyPortal from "../../pages/SocietyPortal/SocietyPortal";
import MasterLayout from "../../masterLayout/SocietyPortal/MasterLayout";
import SocietyPortalLogin from "../../pages/SocietyPortal/Auth/Login/Login";
import SocietyPortalSignUp from "../../pages/SocietyPortal/Auth/Signup/Signup";
import SocietyPortalForgotPassword from "../../pages/SocietyPortal/Auth/ForgotPassword/ForgotPassword";

import SocietyPortalDashboard from "../../pages/SocietyPortal/Dashboard/Dashboard";
import SocietyProfile from "../../pages/SocietyPortal/Society/SocietyProfile/SocietyProfile";
import EditSocietyProfile from "../../pages/SocietyPortal/Society/SocietyProfile/EditSocietyProfile";
import Wings from "../../pages/SocietyPortal/Society/WingsAndFlats/Wings";
import WorkingDocuments from "../../pages/SocietyPortal/Society/WorkingDocuments/WorkingDocuments";
import Flats from "../../pages/SocietyPortal/Society/WingsAndFlats/Flats";

import OwnersPage from "../../pages/SocietyPortal/Society/Members/OwnersPage";
import TenantsPage from "../../pages/SocietyPortal/Society/Members/TenantsPage";
import FamilyPage from "../../pages/SocietyPortal/Society/Members/FamilyPage";
import AddOwner from "../../pages/SocietyPortal/Society/Members/AddOwner";
import AddTenant from "../../pages/SocietyPortal/Society/Members/AddTenant";
import AddFamily from "../../pages/SocietyPortal/Society/Members/AddFamily";

import Employees from "../../pages/SocietyPortal/Employee/Employees";
import AddEmployee from "../../pages/SocietyPortal/Employee/AddEmployee";
import EditEmployee from "../../pages/SocietyPortal/Employee/EditEmployee";
import ViewEmployee from "../../pages/SocietyPortal/Employee/ViewEmployee";
import EmployeeWorkLog from "../../pages/SocietyPortal/Employee/EmployeeWorkLog";
import AttendanceReport from "../../pages/SocietyPortal/Employee/AttendanceReport";
import DailyTodos from "../../pages/SocietyPortal/Employee/DailyTodos";
import PunchAttendance from "../../pages/SocietyPortal/Attendance/PunchAttendance";
import MyAttendance from "../../pages/SocietyPortal/Attendance/MyAttendance";
import ManageAttendance from "../../pages/SocietyPortal/Attendance/ManageAttendance";
import Shifts from "../../pages/SocietyPortal/Shift/Shifts";
import ShiftAssignments from "../../pages/SocietyPortal/Shift/ShiftAssignments";

import MyHome from "../../pages/SocietyPortal/MemberPortal/MyHome";
import MyBills from "../../pages/SocietyPortal/MemberPortal/MyBills";
import MyBillDetail from "../../pages/SocietyPortal/MemberPortal/MyBillDetail";
import MyPayments from "../../pages/SocietyPortal/MemberPortal/MyPayments";
import MyLedger from "../../pages/SocietyPortal/MemberPortal/MyLedger";

import Complaints from "../../pages/SocietyPortal/Complaint/Complaints";
import AddComplaint from "../../pages/SocietyPortal/Complaint/AddComplaint";
import EditComplaint from "../../pages/SocietyPortal/Complaint/EditComplaint";
import ViewComplaint from "../../pages/SocietyPortal/Complaint/ViewComplaint";
import ComplaintCategories from "../../pages/SocietyPortal/Complaint/ComplaintCategories";
import CommitteeOversight from "../../pages/SocietyPortal/Committee/CommitteeOversight";
import EmployeeComplaints from "../../pages/SocietyPortal/Complaint/EmployeeComplaints";
import MyComplaints from "../../pages/SocietyPortal/Complaint/MyComplaints";
import RaiseComplaint from "../../pages/SocietyPortal/Complaint/RaiseComplaint";
import MyComplaintDetail from "../../pages/SocietyPortal/Complaint/MyComplaintDetail";

import Notices from "../../pages/SocietyPortal/Notice/Notices";
import AddNotice from "../../pages/SocietyPortal/Notice/AddNotice";
import EditNotice from "../../pages/SocietyPortal/Notice/EditNotice";
import ViewNotice from "../../pages/SocietyPortal/Notice/ViewNotice";
import NoticeBoard from "../../pages/SocietyPortal/Notice/NoticeBoard";
import PrintNotice from "../../pages/SocietyPortal/Notice/PrintNotice";

import Visitors from "../../pages/SocietyPortal/Visitor/Visitors";
import AddVisitor from "../../pages/SocietyPortal/Visitor/AddVisitor";
import EditVisitor from "../../pages/SocietyPortal/Visitor/EditVisitor";
import ViewVisitor from "../../pages/SocietyPortal/Visitor/ViewVisitor";

import Visits from "../../pages/SocietyPortal/Visitor/Visits/Visits";
import AddVisit from "../../pages/SocietyPortal/Visitor/Visits/AddVisit";
import ViewVisit from "../../pages/SocietyPortal/Visitor/Visits/ViewVisit";
import PreApprovals from "../../pages/SocietyPortal/Visitor/PreApprovals/PreApprovals";
import AddPreApproval from "../../pages/SocietyPortal/Visitor/PreApprovals/AddPreApproval";
import EditPreApproval from "../../pages/SocietyPortal/Visitor/PreApprovals/EditPreApproval";
import GatePasses from "../../pages/SocietyPortal/Visitor/GatePasses/GatePasses";
import AddGatePass from "../../pages/SocietyPortal/Visitor/GatePasses/AddGatePass";
import EditGatePass from "../../pages/SocietyPortal/Visitor/GatePasses/EditGatePass";
import Deliveries from "../../pages/SocietyPortal/Visitor/Deliveries/Deliveries";
import Cabs from "../../pages/SocietyPortal/Visitor/Cabs/Cabs";
import VmsActivityLogs from "../../pages/SocietyPortal/Visitor/ActivityLogs/ActivityLogs";
import VmsSettings from "../../pages/SocietyPortal/Visitor/Settings/VmsSettings";

import Vendors from "../../pages/SocietyPortal/Vendor/Vendors";
import AddVendor from "../../pages/SocietyPortal/Vendor/AddVendor";
import ViewVendor from "../../pages/SocietyPortal/Vendor/ViewVendor";
import EditVendor from "../../pages/SocietyPortal/Vendor/EditVendor";
import VendorBill from "../../pages/SocietyPortal/Vendor/VendorBill";
import AddVendorBill from "../../pages/SocietyPortal/Vendor/AddVendorBill";
import ViewVendorBill from "../../pages/SocietyPortal/Vendor/ViewVendorBill";
import EditVendorBill from "../../pages/SocietyPortal/Vendor/EditVendorBill";
import VendorTariff from "../../pages/SocietyPortal/Vendor/VendorTariff";
import VendorPayment from "../../pages/SocietyPortal/Vendor/VendorPayment";
import VendorVisits from "../../pages/SocietyPortal/Vendor/VendorVisits";
import AddVendorPayment from "../../pages/SocietyPortal/Vendor/AddVendorPayment";
import EditVendorPayment from "../../pages/SocietyPortal/Vendor/EditVendorPayment";
import ViewVendorPayment from "../../pages/SocietyPortal/Vendor/ViewVendorPayment";
import VendorSetting from "../../pages/SocietyPortal/Vendor/VendorSetting";
import VendorSettingCategories from "../../pages/SocietyPortal/Vendor/VendorSettingCategories";
import VendorSettingBilling from "../../pages/SocietyPortal/Vendor/VendorSettingBilling";
import VendorSettingNotifications from "../../pages/SocietyPortal/Vendor/VendorSettingNotifications";
import VendorSettingApprovals from "../../pages/SocietyPortal/Vendor/VendorSettingApprovals";

import Invoices from "../../pages/SocietyPortal/Finance/Invoices/Invoices";
import CreateInvoice from "../../pages/SocietyPortal/Finance/Invoices/CreateInvoice";
import EditInvoice from "../../pages/SocietyPortal/Finance/Invoices/EditInvoice";
import PrintInvoice from "../../pages/SocietyPortal/Finance/Invoices/PrintInvoice";
import BulkPrintInvoices from "../../pages/SocietyPortal/Finance/Invoices/BulkPrintInvoices";
import BulkCreateInvoice from "../../pages/SocietyPortal/Finance/Invoices/BulkCreateInvoice";
import CreditNotes from "../../pages/SocietyPortal/Finance/CreditNotes/CreditNotes";
import CreateCreditNote from "../../pages/SocietyPortal/Finance/CreditNotes/CreateCreditNote";
import PrintNote from "../../pages/SocietyPortal/Finance/CreditNotes/PrintNote";
import BulkPrintNotes from "../../pages/SocietyPortal/Finance/CreditNotes/BulkPrintNotes";
import EditCreditNote from "../../pages/SocietyPortal/Finance/CreditNotes/EditCreditNote";
import DebitNotes from "../../pages/SocietyPortal/Finance/DebitNotes/DebitNotes";
import CreateDebitNote from "../../pages/SocietyPortal/Finance/DebitNotes/CreateDebitNote";
import EditDebitNote from "../../pages/SocietyPortal/Finance/DebitNotes/EditDebitNote";
import BulkUploadCreditDebitNotes from "../../pages/SocietyPortal/Finance/CreditNotes/BulkUploadCreditDebitNotes";
import Receipts from "../../pages/SocietyPortal/Finance/Receipts/Receipts";
import CreateReceipt from "../../pages/SocietyPortal/Finance/Receipts/CreateReceipt";
import PrintReceipt from "../../pages/SocietyPortal/Finance/Receipts/PrintReceipt";
import BulkPrintReceipts from "../../pages/SocietyPortal/Finance/Receipts/BulkPrintReceipts";
import BulkUploadReceipts from "../../pages/SocietyPortal/Finance/Receipts/BulkUploadReceipts";

import BillingTypes from "../../pages/SocietyPortal/Setup/InvoiceSetup/BillingTypes/BillingTypes";
import BillSeries from "../../pages/SocietyPortal/Setup/InvoiceSetup/BillSeries/BillSeries";
import DocumentSeries from "../../pages/SocietyPortal/Setup/InvoiceSetup/DocumentSeries/DocumentSeries";
import ChargeHead from "../../pages/SocietyPortal/Setup/InvoiceSetup/ChargeHead/ChargeHead";
import FunctionalSetting from "../../pages/SocietyPortal/Setup/InvoiceSetup/FunctionalSetting/FunctionalSetting";
import TaxRules from "../../pages/SocietyPortal/Setup/InvoiceSetup/TaxRules/TaxRules";
import MeterReading from "../../pages/SocietyPortal/Setup/InvoiceSetup/MeterReading/MeterReading";
import OpeningBalance from "../../pages/SocietyPortal/Setup/InvoiceSetup/OpeningBalance/OpeningBalance";
import BankAccounts from "../../pages/SocietyPortal/Setup/InvoiceSetup/BankAccounts/BankAccounts";
import Roles from "../../pages/SocietyPortal/Setup/RolesPermissions/Roles";
import RolePermissions from "../../pages/SocietyPortal/Setup/RolesPermissions/RolePermissions";

import Journal from "../../pages/SocietyPortal/Accounts/Journal/Journal";
import AddJournal from "../../pages/SocietyPortal/Accounts/Journal/AddJournal";
import EditJournal from "../../pages/SocietyPortal/Accounts/Journal/EditJournal";
import BulkImportJournal from "../../pages/SocietyPortal/Accounts/Journal/BulkImportJournal";
import ChartOfAccounts from "../../pages/SocietyPortal/Accounts/ChartOfAccounts/ChartOfAccounts";
import Opening from "../../pages/SocietyPortal/Accounts/Opening/Opening";
import Closing from "../../pages/SocietyPortal/Accounts/Closing/Closing";
import MemberDaybook from "../../pages/SocietyPortal/Accounts/MemberDaybook/MemberDaybook";
import FixedAssets from "../../pages/SocietyPortal/Accounts/FixedAssets/FixedAssets";
import AddFixedAssets from "../../pages/SocietyPortal/Accounts/FixedAssets/AddFixedAssets";
import EditFixedAssets from "../../pages/SocietyPortal/Accounts/FixedAssets/EditFixedAssets";
import CashAndBank from "../../pages/SocietyPortal/Accounts/CashAndBank/CashAndBank";
import BankBook from "../../pages/SocietyPortal/Accounts/CashAndBank/BankBook";
import Investments from "../../pages/SocietyPortal/Accounts/Investments/Investments";
import Reconciliation from "../../pages/SocietyPortal/Accounts/Reconciliation/Reconciliation";
import BRSDetail from "../../pages/SocietyPortal/Accounts/Reconciliation/BRSDetail";

import IncomeExpenditureReport from "../../pages/SocietyPortal/AccountsReports/IncomeExpenditure/IncomeExpenditure";
import BalanceSheetReport from "../../pages/SocietyPortal/AccountsReports/BalanceSheet/BalanceSheet";
import TrialBalanceReport from "../../pages/SocietyPortal/AccountsReports/TrialBalance/TrialBalance";
import GroupLedgerReport from "../../pages/SocietyPortal/AccountsReports/GroupLedger/GroupLedger";
import MonthlyIncomeReport from "../../pages/SocietyPortal/AccountsReports/MonthlyIncome/MonthlyIncome";
import MonthlyIncomeExpenditure from "../../pages/SocietyPortal/AccountsReports/MonthlyIncomeExpenditure/MonthlyIncomeExpenditure";
import MonthlyExpenditureReport from "../../pages/SocietyPortal/AccountsReports/MonthlyExpenditure/MonthlyExpenditure";
import AccountLedgerReport from "../../pages/SocietyPortal/Reports/AccountLedgerReport/AccountLedgerReport";

import MemberLedgerReport from "../../pages/SocietyPortal/Reports/MemberLedgerReport/MemberLedgerReport";
import InvoiceReport from "../../pages/SocietyPortal/Reports/InvoiceReport/InvoiceReport";
import InvoiceAgingReport from "../../pages/SocietyPortal/Reports/InvoiceAgingReport/InvoiceAgingReport";
import InterestReport from "../../pages/SocietyPortal/Reports/InterestReport/InterestReport";
import ReceiptReport from "../../pages/SocietyPortal/Reports/ReceiptReport/ReceiptReport";
import CDNoteReport from "../../pages/SocietyPortal/Reports/CDNoteReport/CDNoteReport";
import GSTReport from "../../pages/SocietyPortal/Reports/GSTReport/GSTReport";
import ReconciliationReport from "../../pages/SocietyPortal/Reports/ReconciliationReport/ReconciliationReport";

import PortalViewProfilePage from "../../pages/SocietyPortal/Profile/ViewProfilePage";

import FlatTransferWizard from "../../pages/SocietyPortal/Compliance/FlatTransfer/FlatTransferWizard";
import FlatTransferHistory from "../../pages/SocietyPortal/Compliance/FlatTransfer/FlatTransferHistory";
import FlatTransferDetail from "../../pages/SocietyPortal/Compliance/FlatTransfer/FlatTransferDetail";
import ShareCertificates from "../../pages/SocietyPortal/Compliance/ShareCertificate/ShareCertificates";
import ShareCertificateDetail from "../../pages/SocietyPortal/Compliance/ShareCertificate/ShareCertificateDetail";

import Tasks from "../../pages/SocietyPortal/Task/Tasks";
import Task from "../../pages/SocietyPortal/Task/Task";
import AddTask from "../../pages/SocietyPortal/Task/AddTask";
import EditTask from "../../pages/SocietyPortal/Task/EditTask";
import ViewTask from "../../pages/SocietyPortal/Task/ViewTask";
import Projects from "../../pages/SocietyPortal/Task/Projects";
import Board from "../../pages/SocietyPortal/Task/Board";
import ProjectTasks from "../../pages/SocietyPortal/Task/ProjectTasks";
import TaskDashboard from "../../pages/SocietyPortal/Task/TaskDashboard";

const strip = (path) => path.replace(/^\//, "");
const guard = (perms, component) => (
  <PermissionOnComponent permissions={perms} component={component} />
);

// The portal's "/" — where login and the logo link go. A role holding
// dashboard.read opens the admin dashboard, any other goes where portalLanding
// says rather than to a dashboard of 403 toasts. The sidebar hides the Dashboard
// entry on the same code.
const PortalLanding = () => {
  const permissions = useSelector((s) => s.UserSocietyReducer?.permissions || []);
  const permissionsLoading = useSelector((s) => s.UserSocietyReducer?.permissionsLoading);

  if (permissionsLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }
  const landing = portalLanding(permissions);
  if (landing) return <Navigate to={routes.SOCIETY_PORTAL + landing} replace />;

  return <SocietyPortalDashboard />;
};

const SocietyPortalRouter = () => (
  <Routes>
    {/* Public auth routes */}
    <Route path={strip(routes.SOCIETY_PORTAL_LOGIN)} element={<SocietyPortalLogin />} />
    <Route path={strip(routes.SOCIETY_PORTAL_SIGN_UP)} element={<SocietyPortalSignUp />} />
    <Route
      path={strip(routes.SOCIETY_PORTAL_FORGOT_PASSWORD)}
      element={<SocietyPortalForgotPassword />}
    />

    {/* Authenticated portal */}
    <Route element={<SocietyPortal />}>
      <Route element={<ProtectedRoute />}>
        <Route element={<MasterLayout />}>
          {/* Landing & profile — accessible to any authenticated user. The
              landing picks the admin dashboard or My Home by permission. */}
          <Route index element={<PortalLanding />} />
          <Route
            path={strip(routes.SOCIETY_PORTAL_PROFILE)}
            element={<PortalViewProfilePage />}
          />

          {/* Society Profile */}
          <Route
            path="society-profile"
            element={guard([PERMISSIONS.SOCIETY_READ], <SocietyProfile />)}
          />
          <Route
            path="society-profile/edit"
            element={guard([PERMISSIONS.SOCIETY_UPDATE], <EditSocietyProfile />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_WINGS)}
            element={guard([PERMISSIONS.WING_READ], <Wings />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_WORKING_DOCUMENTS)}
            element={guard([PERMISSIONS.SOCIETY_DOCUMENT_READ], <WorkingDocuments />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_FLATS)}
            element={guard([PERMISSIONS.FLAT_READ], <Flats />)}
          />

          {/* Members — redirect is ungated; landing list pages use entity/occupant read */}
          <Route
            path={strip(routes.SOCIETY_PORTAL_MEMBERS)}
            element={
              <Navigate
                to={routes.SOCIETY_PORTAL + routes.SOCIETY_PORTAL_MEMBERS_OWNERS}
                replace
              />
            }
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_MEMBERS_OWNERS)}
            element={guard([PERMISSIONS.ENTITY_READ], <OwnersPage />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_MEMBERS_TENANTS)}
            element={guard([PERMISSIONS.OCCUPANT_READ], <TenantsPage />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_MEMBERS_FAMILY)}
            element={guard([PERMISSIONS.OCCUPANT_READ], <FamilyPage />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_MEMBERS_ADD_OWNER)}
            element={guard([PERMISSIONS.ENTITY_CREATE], <AddOwner />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_MEMBERS_ADD_TENANT)}
            element={guard([PERMISSIONS.OCCUPANT_CREATE], <AddTenant />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_MEMBERS_ADD_FAMILY)}
            element={guard([PERMISSIONS.OCCUPANT_CREATE], <AddFamily />)}
          />

          {/* Employees */}
          <Route path={strip(routes.SOCIETY_PORTAL_EMPLOYEES)} element={<Employees />} />
          <Route path={strip(routes.SOCIETY_PORTAL_EMPLOYEES_ADD)} element={<AddEmployee />} />
          <Route path={strip(routes.SOCIETY_PORTAL_EMPLOYEES_VIEW)} element={<ViewEmployee />} />
          <Route path={strip(routes.SOCIETY_PORTAL_EMPLOYEES_EDIT)} element={<EditEmployee />} />
          <Route
            path={strip(routes.SOCIETY_PORTAL_EMPLOYEES_WORK_LOG)}
            element={guard([PERMISSIONS.EMPLOYEE_WORK_LOG], <EmployeeWorkLog />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_EMPLOYEES_DAILY_TODO)}
            element={guard([PERMISSIONS.EMPLOYEE_READ], <DailyTodos />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_ATTENDANCE_REPORT)}
            element={guard([PERMISSIONS.LOGIN_HISTORY_READ], <AttendanceReport />)}
          />

          {/* Employee self-service attendance — no permission guard: any active
              employee may punch; the backend rejects non-employees and the page
              renders a friendly state for NOT_AN_EMPLOYEE / ATTENDANCE_DISABLED. */}
          <Route path={strip(routes.SOCIETY_PORTAL_PUNCH_ATTENDANCE)} element={<PunchAttendance />} />
          <Route path={strip(routes.SOCIETY_PORTAL_MY_ATTENDANCE)} element={<MyAttendance />} />
          <Route
            path={strip(routes.SOCIETY_PORTAL_MANAGE_ATTENDANCE)}
            element={guard([PERMISSIONS.ATTENDANCE_READ_ALL], <ManageAttendance />)}
          />

          {/* Shifts — the definitions, and who is assigned to which. Assigning
              from the employee form is the primary path; the assignments screen
              handles what that form refuses (future dates, back-dated fixes). */}
          <Route
            path={strip(routes.SOCIETY_PORTAL_SHIFTS)}
            element={guard([PERMISSIONS.SHIFT_READ], <Shifts />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_SHIFT_ASSIGNMENTS)}
            element={guard([PERMISSIONS.SHIFT_READ], <ShiftAssignments />)}
          />

          {/* Member self-service — ungated for the same reason as the notice
              board and the attendance punch screens: these read only the
              caller's own flats, so membership is the check, not a permission.
              The backend enforces that scope; the FE just asks for `mine`. */}
          <Route path={strip(routes.SOCIETY_PORTAL_MY_HOME)} element={<MyHome />} />
          <Route path={strip(routes.SOCIETY_PORTAL_MY_BILL_DETAIL)} element={<MyBillDetail />} />
          <Route path={strip(routes.SOCIETY_PORTAL_MY_BILLS)} element={<MyBills />} />
          <Route path={strip(routes.SOCIETY_PORTAL_MY_PAYMENTS)} element={<MyPayments />} />
          <Route path={strip(routes.SOCIETY_PORTAL_MY_LEDGER)} element={<MyLedger />} />

          {/* Complaints — the resident's list, raise and detail screens run on
              /api/member/complaints*, so member_portal.complaints is all a
              resident role needs; no complaint.* staff permission. */}
          <Route
            path={strip(routes.SOCIETY_PORTAL_MY_COMPLAINTS_RAISE)}
            element={guard([PERMISSIONS.MEMBER_PORTAL_COMPLAINTS], <RaiseComplaint />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_MY_COMPLAINTS_VIEW)}
            element={guard([PERMISSIONS.MEMBER_PORTAL_COMPLAINTS], <MyComplaintDetail />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_MY_COMPLAINTS)}
            element={guard([PERMISSIONS.MEMBER_PORTAL_COMPLAINTS], <MyComplaints />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_COMPLAINT_CATEGORIES)}
            element={guard([PERMISSIONS.COMPLAINT_READ], <ComplaintCategories />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_EMPLOYEE_COMPLAINTS)}
            element={guard([PERMISSIONS.COMPLAINT_READ], <EmployeeComplaints />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_COMPLAINTS)}
            element={guard([PERMISSIONS.COMPLAINT_READ, PERMISSIONS.COMPLAINT_READ_OWN], <Complaints />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_COMPLAINTS_ADD)}
            element={guard([PERMISSIONS.COMPLAINT_CREATE], <AddComplaint />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_COMPLAINTS_VIEW)}
            element={guard([PERMISSIONS.COMPLAINT_READ, PERMISSIONS.COMPLAINT_READ_OWN], <ViewComplaint />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_COMPLAINTS_EDIT)}
            element={guard([PERMISSIONS.COMPLAINT_UPDATE], <EditComplaint />)}
          />

          {/* Notices & Circulars — the board itself is ungated so every
              authenticated resident/employee can read what was published to
              them; the admin screens below stay permission-gated. */}
          <Route
            path={strip(routes.SOCIETY_PORTAL_NOTICE_BOARD)}
            element={<NoticeBoard />}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_NOTICES_ADD)}
            element={guard([PERMISSIONS.NOTICE_CREATE], <AddNotice />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_NOTICES_VIEW)}
            element={guard([PERMISSIONS.NOTICE_READ], <ViewNotice />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_NOTICES_PRINT)}
            element={guard([PERMISSIONS.NOTICE_READ], <PrintNotice />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_NOTICES_EDIT)}
            element={guard([PERMISSIONS.NOTICE_UPDATE], <EditNotice />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_NOTICES)}
            element={guard([PERMISSIONS.NOTICE_READ], <Notices />)}
          />

          {/* Visitor Management (VMS) */}
          <Route
            path={strip(routes.SOCIETY_PORTAL_VISITORS_ADD)}
            element={guard([PERMISSIONS.VMS_VISITOR_CREATE], <AddVisitor />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_VISITORS_VIEW)}
            element={guard([PERMISSIONS.VMS_VISITOR_READ], <ViewVisitor />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_VISITORS_EDIT)}
            element={guard([PERMISSIONS.VMS_VISITOR_UPDATE], <EditVisitor />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_VISITS_ADD)}
            element={guard([PERMISSIONS.VMS_VISITOR_CREATE], <AddVisit />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_VISITS_VIEW)}
            element={guard([PERMISSIONS.VMS_VISITOR_READ], <ViewVisit />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_VISITS)}
            element={guard([PERMISSIONS.VMS_VISITOR_READ], <Visits />)}
          />

          <Route
            path={strip(routes.SOCIETY_PORTAL_PRE_APPROVALS_ADD)}
            element={guard([PERMISSIONS.VMS_PRE_APPROVAL_CREATE], <AddPreApproval />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_PRE_APPROVALS_EDIT)}
            element={guard([PERMISSIONS.VMS_PRE_APPROVAL_UPDATE], <EditPreApproval />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_PRE_APPROVALS)}
            element={guard([PERMISSIONS.VMS_PRE_APPROVAL_READ], <PreApprovals />)}
          />

          <Route
            path={strip(routes.SOCIETY_PORTAL_GATE_PASSES_ADD)}
            element={guard([PERMISSIONS.VMS_GATE_PASS_CREATE], <AddGatePass />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_GATE_PASSES_EDIT)}
            element={guard([PERMISSIONS.VMS_GATE_PASS_UPDATE], <EditGatePass />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_GATE_PASSES)}
            element={guard([PERMISSIONS.VMS_GATE_PASS_READ], <GatePasses />)}
          />

          <Route
            path={strip(routes.SOCIETY_PORTAL_DELIVERIES)}
            element={guard([PERMISSIONS.VMS_DELIVERY_READ], <Deliveries />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_CABS)}
            element={guard([PERMISSIONS.VMS_CAB_READ], <Cabs />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_VMS_ACTIVITY_LOGS)}
            element={guard([PERMISSIONS.VMS_VISITOR_LOG_READ], <VmsActivityLogs />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_VMS_SETTINGS)}
            element={guard([PERMISSIONS.VMS_SETTINGS_READ], <VmsSettings />)}
          />

          <Route
            path={strip(routes.SOCIETY_PORTAL_VISITORS)}
            element={guard([PERMISSIONS.VMS_VISITOR_READ], <Visitors />)}
          />

          {/* Vendors */}
          <Route
            path={strip(routes.SOCIETY_PORTAL_VENDORS)}
            element={guard([PERMISSIONS.VENDOR_READ], <Vendors />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_VENDORS_ADD)}
            element={guard([PERMISSIONS.VENDOR_CREATE], <AddVendor />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_VENDORS_VIEW)}
            element={guard([PERMISSIONS.VENDOR_READ], <ViewVendor />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_VENDORS_EDIT)}
            element={guard([PERMISSIONS.VENDOR_UPDATE], <EditVendor />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_VENDOR_BILLS)}
            element={guard([PERMISSIONS.VENDOR_BILL_READ], <VendorBill />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_VENDOR_BILLS_ADD)}
            element={guard([PERMISSIONS.VENDOR_BILL_CREATE], <AddVendorBill />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_VENDOR_BILLS_VIEW)}
            element={guard([PERMISSIONS.VENDOR_BILL_READ], <ViewVendorBill />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_VENDOR_BILLS_EDIT)}
            element={guard([PERMISSIONS.VENDOR_BILL_UPDATE], <EditVendorBill />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_VENDOR_TARIFFS)}
            element={guard([PERMISSIONS.VENDOR_TARIFF_READ], <VendorTariff />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_VENDOR_PAYMENTS)}
            element={guard([PERMISSIONS.VENDOR_PAYMENT_READ], <VendorPayment />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_VENDOR_VISITS)}
            element={guard([PERMISSIONS.VENDOR_READ], <VendorVisits />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_VENDOR_PAYMENTS_ADD)}
            element={guard([PERMISSIONS.VENDOR_PAYMENT_CREATE], <AddVendorPayment />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_VENDOR_PAYMENTS_VIEW)}
            element={guard([PERMISSIONS.VENDOR_PAYMENT_READ], <ViewVendorPayment />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_VENDOR_PAYMENTS_EDIT)}
            element={guard([PERMISSIONS.VENDOR_PAYMENT_UPDATE], <EditVendorPayment />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_VENDOR_SETTINGS)}
            element={guard([PERMISSIONS.VENDOR_SETTING_READ], <VendorSetting />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_VENDOR_SETTINGS_CATEGORIES)}
            element={guard([PERMISSIONS.VENDOR_CATEGORY_READ], <VendorSettingCategories />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_VENDOR_SETTINGS_BILLING)}
            element={guard([PERMISSIONS.VENDOR_SETTING_READ], <VendorSettingBilling />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_VENDOR_SETTINGS_NOTIFICATIONS)}
            element={guard([PERMISSIONS.VENDOR_SETTING_READ], <VendorSettingNotifications />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_VENDOR_SETTINGS_APPROVALS)}
            element={guard([PERMISSIONS.VENDOR_SETTING_READ], <VendorSettingApprovals />)}
          />

          {/* Task Management */}
          <Route
            path={strip(routes.SOCIETY_PORTAL_TASKS_DASHBOARD)}
            element={guard([PERMISSIONS.TASK_DASHBOARD], <TaskDashboard />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_TASK_PROJECTS)}
            element={guard([PERMISSIONS.TASK_READ, PERMISSIONS.TASK_READ_OWN], <Projects />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_TASK_PROJECT_DETAIL)}
            element={guard([PERMISSIONS.TASK_READ, PERMISSIONS.TASK_READ_OWN], <ProjectTasks />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_TASKS_LIST)}
            element={guard([PERMISSIONS.TASK_READ, PERMISSIONS.TASK_READ_OWN], <Task />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_COMMITTEE_OVERSIGHT)}
            element={guard([PERMISSIONS.COMMITTEE_OVERSIGHT], <CommitteeOversight />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_TASKS_BOARD)}
            element={guard([PERMISSIONS.TASK_READ, PERMISSIONS.TASK_READ_OWN], <Board />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_TASKS_ADD)}
            element={guard([PERMISSIONS.TASK_CREATE], <AddTask />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_TASKS_EDIT)}
            element={guard([PERMISSIONS.TASK_UPDATE], <EditTask />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_TASKS_VIEW)}
            element={guard([PERMISSIONS.TASK_READ, PERMISSIONS.TASK_READ_OWN], <ViewTask />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_TASKS)}
            element={guard([PERMISSIONS.TASK_READ, PERMISSIONS.TASK_READ_OWN], <Tasks />)}
          />

          {/* Finance */}
          <Route
            path={strip(routes.SOCIETY_PORTAL_INVOICES)}
            element={guard([PERMISSIONS.INVOICE_READ], <Invoices />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_INVOICES_CREATE)}
            element={guard([PERMISSIONS.INVOICE_CREATE], <CreateInvoice />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_INVOICES_EDIT)}
            element={guard([PERMISSIONS.INVOICE_UPDATE], <EditInvoice />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_INVOICES_PRINT)}
            element={guard([PERMISSIONS.INVOICE_READ], <PrintInvoice />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_INVOICES_BULK_PRINT)}
            element={guard([PERMISSIONS.INVOICE_READ], <BulkPrintInvoices />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_INVOICES_BULK_CREATE)}
            element={guard([PERMISSIONS.INVOICE_CREATE], <BulkCreateInvoice />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_CREDIT_NOTES)}
            element={guard([PERMISSIONS.CREDIT_NOTE_READ], <CreditNotes />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_CREDIT_NOTES_CREATE)}
            element={guard([PERMISSIONS.CREDIT_NOTE_CREATE], <CreateCreditNote />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_CREDIT_NOTES_EDIT)}
            element={guard([PERMISSIONS.CREDIT_NOTE_UPDATE], <EditCreditNote />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_CREDIT_NOTES_PRINT)}
            element={guard([PERMISSIONS.CREDIT_NOTE_READ], <PrintNote />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_CREDIT_NOTES_BULK_PRINT)}
            element={guard([PERMISSIONS.CREDIT_NOTE_READ], <BulkPrintNotes />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_CREDIT_NOTES_BULK_UPLOAD)}
            element={guard(
              [PERMISSIONS.CREDIT_NOTE_CREATE],
              <BulkUploadCreditDebitNotes noteType="CREDIT_NOTE" />
            )}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_DEBIT_NOTES)}
            element={guard([PERMISSIONS.DEBIT_NOTE_READ], <DebitNotes />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_DEBIT_NOTES_CREATE)}
            element={guard([PERMISSIONS.DEBIT_NOTE_CREATE], <CreateDebitNote />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_DEBIT_NOTES_EDIT)}
            element={guard([PERMISSIONS.DEBIT_NOTE_UPDATE], <EditDebitNote />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_DEBIT_NOTES_PRINT)}
            element={guard([PERMISSIONS.DEBIT_NOTE_READ], <PrintNote />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_DEBIT_NOTES_BULK_PRINT)}
            element={guard([PERMISSIONS.DEBIT_NOTE_READ], <BulkPrintNotes />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_DEBIT_NOTES_BULK_UPLOAD)}
            element={guard(
              [PERMISSIONS.DEBIT_NOTE_CREATE],
              <BulkUploadCreditDebitNotes noteType="DEBIT_NOTE" />
            )}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_RECEIPTS)}
            element={guard([PERMISSIONS.RECEIPT_READ], <Receipts />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_RECEIPTS_CREATE)}
            element={guard([PERMISSIONS.RECEIPT_CREATE], <CreateReceipt />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_RECEIPTS_PRINT)}
            element={guard([PERMISSIONS.RECEIPT_READ], <PrintReceipt />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_RECEIPTS_BULK_PRINT)}
            element={guard([PERMISSIONS.RECEIPT_READ], <BulkPrintReceipts />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_RECEIPTS_BULK_UPLOAD)}
            element={guard([PERMISSIONS.RECEIPT_CREATE], <BulkUploadReceipts />)}
          />

          {/* Setup & Records */}
          <Route
            path={strip(routes.SOCIETY_PORTAL_SETUP_BILLING_TYPES)}
            element={guard([PERMISSIONS.INVOICE_TYPE_READ], <BillingTypes />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_SETUP_BILL_SERIES)}
            element={guard([PERMISSIONS.DOCUMENT_SERIES_READ], <BillSeries />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_SETUP_DOCUMENT_SERIES)}
            element={guard([PERMISSIONS.DOCUMENT_SERIES_READ], <DocumentSeries />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_SETUP_CHARGE_HEADS)}
            element={guard([PERMISSIONS.TARIFF_HEAD_READ], <ChargeHead />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_SETUP_FUNCTIONAL_SETTING)}
            element={guard([PERMISSIONS.INVOICE_SETTING_READ], <FunctionalSetting />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_SETUP_TAX_RULES)}
            element={guard([PERMISSIONS.TAX_RULE_READ], <TaxRules />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_SETUP_METER_READING)}
            element={guard([PERMISSIONS.METER_READING_READ], <MeterReading />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_SETUP_OPENING_BALANCE)}
            element={guard([PERMISSIONS.OPENING_BALANCE_READ], <OpeningBalance />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_SETUP_BANK_ACCOUNTS)}
            element={guard([PERMISSIONS.SOCIETY_BANK_READ], <BankAccounts />)}
          />

          {/* Roles & Permissions */}
          <Route
            path={strip(routes.SOCIETY_PORTAL_ROLES)}
            element={guard([PERMISSIONS.ROLE_READ], <Roles />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_ROLES_PERMISSIONS)}
            element={guard([PERMISSIONS.ROLE_ASSIGN_PERMISSIONS], <RolePermissions />)}
          />

          {/* Accounts */}
          <Route
            path={strip(routes.SOCIETY_PORTAL_ACCOUNTS_JOURNAL)}
            element={guard([PERMISSIONS.JOURNAL_READ], <Journal />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_ACCOUNTS_JOURNAL_ADD)}
            element={guard([PERMISSIONS.JOURNAL_CREATE], <AddJournal />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_ACCOUNTS_JOURNAL_EDIT)}
            element={guard([PERMISSIONS.JOURNAL_UPDATE], <EditJournal />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_ACCOUNTS_JOURNAL_BULK_IMPORT)}
            element={guard([PERMISSIONS.JOURNAL_IMPORT], <BulkImportJournal />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_ACCOUNTS_CHART_OF_ACCOUNTS)}
            element={guard([PERMISSIONS.CHART_OF_ACCOUNT_READ], <ChartOfAccounts />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_ACCOUNTS_OPENING)}
            element={guard([PERMISSIONS.OPENING_BALANCE_READ], <Opening />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_ACCOUNTS_CLOSING)}
            element={guard([PERMISSIONS.CLOSING_READ], <Closing />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_ACCOUNTS_MEMBER_DAYBOOK)}
            element={guard([PERMISSIONS.MEMBER_DAYBOOK_READ], <MemberDaybook />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_ACCOUNTS_FIXED_ASSETS)}
            element={guard([PERMISSIONS.FIXED_ASSET_READ], <FixedAssets />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_ACCOUNTS_FIXED_ASSETS_ADD)}
            element={guard([PERMISSIONS.FIXED_ASSET_CREATE], <AddFixedAssets />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_ACCOUNTS_FIXED_ASSETS_EDIT)}
            element={guard([PERMISSIONS.FIXED_ASSET_UPDATE], <EditFixedAssets />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_ACCOUNTS_CASH_AND_BANK)}
            element={guard([PERMISSIONS.CASH_BANK_READ], <CashAndBank />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_ACCOUNTS_CASH_AND_BANK_BOOK)}
            element={guard([PERMISSIONS.CASH_BANK_READ], <BankBook />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_ACCOUNTS_INVESTMENTS)}
            element={guard([PERMISSIONS.INVESTMENT_READ], <Investments />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_ACCOUNTS_RECONCILIATION)}
            element={guard([PERMISSIONS.RECONCILIATION_READ], <Reconciliation />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_ACCOUNTS_RECONCILIATION_DETAIL)}
            element={guard([PERMISSIONS.RECONCILIATION_READ], <BRSDetail />)}
          />

          {/* Accounts Reports */}
          <Route
            path={strip(routes.SOCIETY_PORTAL_ACCOUNTS_REPORTS_INCOME_EXPENDITURE)}
            element={guard(
              [PERMISSIONS.INCOME_EXPENDITURE_REPORT_VIEW],
              <IncomeExpenditureReport />
            )}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_ACCOUNTS_REPORTS_BALANCE_SHEET)}
            element={guard([PERMISSIONS.BALANCE_SHEET_REPORT_VIEW], <BalanceSheetReport />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_ACCOUNTS_REPORTS_TRIAL_BALANCE)}
            element={guard([PERMISSIONS.TRIAL_BALANCE_REPORT_VIEW], <TrialBalanceReport />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_ACCOUNTS_REPORTS_GROUP_LEDGER)}
            element={guard([PERMISSIONS.GENERAL_LEDGER_REPORT_VIEW], <GroupLedgerReport />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_ACCOUNTS_REPORTS_ACCOUNT_LEDGER)}
            element={guard([PERMISSIONS.GENERAL_LEDGER_REPORT_VIEW], <AccountLedgerReport />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_ACCOUNTS_REPORTS_MONTHLY_INCOME)}
            element={guard(
              [PERMISSIONS.INCOME_EXPENDITURE_REPORT_VIEW],
              <MonthlyIncomeReport />
            )}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_ACCOUNTS_REPORTS_MONTHLY_INCOME_EXPENDITURE)}
            element={guard(
              [PERMISSIONS.INCOME_EXPENDITURE_REPORT_VIEW],
              <MonthlyIncomeExpenditure />
            )}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_ACCOUNTS_REPORTS_MONTHLY_EXPENDITURE)}
            element={guard(
              [PERMISSIONS.INCOME_EXPENDITURE_REPORT_VIEW],
              <MonthlyExpenditureReport />
            )}
          />

          {/* Compliance — Flat Transfer & Share Certificates */}
          <Route
            path={strip(routes.SOCIETY_PORTAL_FLAT_TRANSFER_WIZARD)}
            element={guard([PERMISSIONS.FLAT_TRANSFER_CREATE], <FlatTransferWizard />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_FLAT_TRANSFER_HISTORY)}
            element={guard([PERMISSIONS.FLAT_TRANSFER_READ], <FlatTransferHistory />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_FLAT_TRANSFER_DETAIL)}
            element={guard([PERMISSIONS.FLAT_TRANSFER_READ], <FlatTransferDetail />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_SHARE_CERTIFICATES)}
            element={guard([PERMISSIONS.SHARE_CERTIFICATE_READ], <ShareCertificates />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_SHARE_CERTIFICATE_DETAIL)}
            element={guard([PERMISSIONS.SHARE_CERTIFICATE_READ], <ShareCertificateDetail />)}
          />

          {/* Reports */}
          <Route
            path={strip(routes.SOCIETY_PORTAL_REPORTS_MEMBER_LEDGER)}
            element={guard([PERMISSIONS.MEMBER_LEDGER_REPORT_VIEW], <MemberLedgerReport />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_REPORTS_INVOICE)}
            element={guard([PERMISSIONS.INVOICE_REPORT_VIEW], <InvoiceReport />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_REPORTS_INVOICE_AGING)}
            element={guard([PERMISSIONS.INVOICE_AGING_REPORT_VIEW], <InvoiceAgingReport />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_REPORTS_INTEREST)}
            element={guard([PERMISSIONS.INTEREST_REPORT_VIEW], <InterestReport />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_REPORTS_RECEIPT)}
            element={guard([PERMISSIONS.RECEIPT_REPORT_VIEW], <ReceiptReport />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_REPORTS_CD_NOTE)}
            element={guard([PERMISSIONS.CD_NOTE_REPORT_VIEW], <CDNoteReport />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_REPORTS_GST)}
            element={guard([PERMISSIONS.GST_REPORT_VIEW], <GSTReport />)}
          />
          <Route
            path={strip(routes.SOCIETY_PORTAL_REPORTS_RECONCILIATION)}
            element={guard([PERMISSIONS.RECONCILIATION_REPORT_VIEW], <ReconciliationReport />)}
          />
        </Route>
      </Route>
    </Route>
  </Routes>
);

export default SocietyPortalRouter;
